module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("About the Author")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A varied and adaptable writer, Joe Clements made his first splash in the world of literature in Flash Fiction Magazine with his intense psychological short, "), _c('em', [_vm._v("Modern Medicine")]), _vm._v(". Since then he has developed several fictional universes, one of which playing host to his condensed sci-fi epic, "), _c('em', [_vm._v("System Reset")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Clements’ dynamic and versatile style is influenced by everything from classic literature and poetry to films, video games, death metal music and even a deep interest in neuroscience and philosophy. A man of emotion, he is eager to invoke a plethora of which within the bleak, extreme and disconcerting.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0